// Credit limits and optimal ranges
export const CREDIT_LIMITS = {
  SEMESTER_MAX: 45,
  SEMESTER_OPTIMAL: 30,
  SEMESTER_OPTIMAL_RANGE: 5, // 30 ± 5 = 25-35
  PERIOD_OPTIMAL: 15,
  PERIOD_OPTIMAL_RANGE: 3, // 15 ± 3 = 12-18
  TOTAL_REQUIRED: 120,
};

// Academic year structure
export const ACADEMIC_STRUCTURE = {
  VALID_YEARS: {
    2025: [1],
    2026: [2, 3],
    2027: [4],
  },
  SEASON_NAMES: {
    1: 'Autumn',
    2: 'Spring',
    3: 'Autumn', 
    4: 'Spring',
  },
};

// UI Constants
export const UI_CONSTANTS = {
  ORDINAL_SUFFIXES: ['th', 'st', 'nd', 'rd'],
  EXPAND_ICON: '▼',
  COLLAPSE_ICON: '►',
}; 